(function () {

	"use strict";

	angular
		.module("vertica.animation", [])
		.factory("animation", animation);

	animation.$inject = [];

	var rAF = window["requestAnimationFrame"] || window["webkitRequestAnimationFrame"] || window["mozRequestAnimationFrame"];
	var cAF = window["cancelAnimationFrame"] || window["webkitCancelAnimationFrame"] || window["webkitCancelRequestAnimationFrame"] || window["mozCancelRequestAnimationFrame"];

	var ns = 0;
    // Below is commented out because ios devices throw an error when not in debug mode
	// if (performance && angular.isFunction(performance.now) && performance.timing) ns = performance.timing.navigationStart;

	function animation () {
		return {
			rAF: function (fn, context) {
				return rAF(function (timestamp) {
					fn.apply(context, [timestamp + ns]);
				});
			},
			cAF: function (id) {
				cAF(id);
			}
		};
	}

})();